import { INPUT_PADDING } from '@components/Input/constants';
export const calculateRows = (
  target,
  { minRows, textareaLineHeight, maxRows },
) => {
  const previousRows = target.rows;
  target.rows = minRows;
  let currentRows = Math.floor(
    (target.scrollHeight - INPUT_PADDING * 2) / textareaLineHeight,
  );
  // enforce use min rows
  currentRows = currentRows || minRows;
  if (currentRows === previousRows) {
    target.rows = currentRows;
  }
  if (currentRows >= maxRows) {
    target.rows = maxRows;
    target.scrollTop = target.scrollHeight;
  }

  return currentRows < maxRows ? currentRows : maxRows;
};
